import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { buildApiUrl, buildRequestHeaders } from '@dental-ui/shared/consts';
import { ResponseModel } from '@dental-ui/auth';
import {
  WhatsAppConfigData,
  WhatsAppConnectRequest,
  WhatsAppConnectionStatus,
  WhatsAppGraphErrorResponse,
  WhatsAppSendTestRequest,
} from '../models/whatsapp.models';

@Injectable({
  providedIn: 'root',
})
export class WhatsappApiService {
  private readonly http = inject(HttpClient);

  getConfig(authorize = true): Observable<ResponseModel<WhatsAppConfigData>> {
    return this.http.get<ResponseModel<WhatsAppConfigData>>(
      buildApiUrl('whatsapp.getConfig'),
      { headers: buildRequestHeaders(authorize) }
    );
  }

  connect(payload: WhatsAppConnectRequest, authorize = true): Observable<ResponseModel<WhatsAppConnectionStatus>> {
    if (!payload.wabaId && !payload.phoneNumberId && !payload.code) {
      return of({
        success: false,
        message: 'Geçersiz veya boş bağlantı bilgileri.',
        data: { connected: false },
      } as ResponseModel<WhatsAppConnectionStatus>);
    }

    return this.http.post<ResponseModel<WhatsAppConnectionStatus>>(
      buildApiUrl('whatsapp.connect'),
      payload,
      { headers: buildRequestHeaders(authorize) }
    );
  }

  getStatus(authorize = true): Observable<ResponseModel<WhatsAppConnectionStatus>> {
    return this.http.get<ResponseModel<WhatsAppConnectionStatus>>(
      buildApiUrl('whatsapp.getStatus'),
      { headers: buildRequestHeaders(authorize) }
    );
  }

  disconnect(authorize = true): Observable<ResponseModel<boolean>> {
    return this.http.post<ResponseModel<boolean>>(
      buildApiUrl('whatsapp.disconnect'),
      {},
      { headers: buildRequestHeaders(authorize) }
    );
  }

  sendTestMessage(
    payload: WhatsAppSendTestRequest,
    authorize = true
  ): Observable<ResponseModel<{ messageId: string }>> {
    return this.http.post<ResponseModel<{ messageId: string }>>(
      buildApiUrl('whatsapp.sendTest'),
      payload,
      { headers: buildRequestHeaders(authorize) }
    );
  }

  canSendDirectTest(): boolean {
    return false;
  }

  private buildDirectMessageBody(to: string, message: string): Record<string, unknown> {
    const normalizedTo = to.replace(/\D/g, '');

    if (message.trim()) {
      return {
        messaging_product: 'whatsapp',
        to: normalizedTo,
        type: 'text',
        text: { body: message.trim() },
      };
    }

    return {
      messaging_product: 'whatsapp',
      to: normalizedTo,
      type: 'template',
      template: {
        name: 'hello_world',
        language: { code: 'en_US' },
      },
    };
  }

  extractGraphError(error: unknown): string {
    if (error && typeof error === 'object' && 'error' in error) {
      const httpError = error as { error?: WhatsAppGraphErrorResponse };
      return httpError.error?.error?.message ?? 'WhatsApp mesajı gönderilemedi.';
    }
    return 'WhatsApp mesajı gönderilemedi.';
  }
}
